const useManagerUserPermissionsList = (permissionsGroup, studioPermissionsToIterate) => {
  // const studioPermissionsToIterate2 = studioPermissionsToIterate[3];
  // const studioPermissionsToIterate3 = studioPermissionsToIterate[0];

  const group1 = permissionsGroup.filter(g => g.groupId === "8");
  const group2 = permissionsGroup.filter(g => g.groupId === "1");
  const group3 = permissionsGroup.filter(g => g.groupId === "14");
  const group4 = permissionsGroup.filter(g => g.groupId === "6");
  const group5 = permissionsGroup.filter(g => g.groupId === "13" );

  const permissionsList1 = group1[0].permissions;
  const permissionsList2 = group4[0].permissions;
  const permissionsList3 = group2[0].permissions;
  const permissionsList4 = group3[0].permissions;
  const permissionsList5 = group5[0].permissions;

  // const permissionsList2WithCompanyRaw = permissionsList2.map((perm) => {
  // 	return studioPermissionsToIterate2.map(stPerm => {
  // 		if(perm.functionId === stPerm.functionId){
  // 			return {
  // 				...perm,
  // 				companyPermission: stPerm.isActive === true ? true : false
  // 			};
  // 		};
  // 		return perm;
  // 	});
  // });
  // const permissionsList3WithCompanyRaw = permissionsList3.map((perm) => {
  // 	return studioPermissionsToIterate3.map(stPerm => {
  // 		if(perm.functionId === stPerm.functionId){
  // 			return {
  // 				...perm,
  // 				companyPermission: stPerm.isActive === true ? true : false
  // 			};
  // 		};
  // 		return perm;
  // 	});
  // });
  // const permissionsList2WithCompany = permissionsList2WithCompanyRaw.map(x => {
  // 	return x.find(y => {
  // 		return y.hasOwnProperty("companyPermission");
  // 	});
  // });
  // const permissionsList3WithCompany = permissionsList3WithCompanyRaw.map(x => {
  // 	return x.find(y => {
  // 		return y.hasOwnProperty("companyPermission");
  // 	});
  // });

  const permissionsListStructure = [
    {
      listToIterate: permissionsList5,
      index: 10,
      listLabel: "permissionsList5"
    },
    {
      listToIterate: permissionsList1,
      index: 5,
      listLabel: "permissionsList1"
    },
    {
      listToIterate: permissionsList2,
      index: 3,
      listLabel: "permissionsList2"
    },
    {
      listToIterate: permissionsList3,
      index: 0,
      listLabel: "permissionsList3"
    },
    {
      listToIterate: permissionsList4,
      index: 11,
      listLabel: "permissionsList4"
    }
  ];
  return permissionsListStructure;
};

export default useManagerUserPermissionsList;